import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Base_Url } from '../config';
import { useSelector } from 'react-redux';

const AddContactInfo = () => {

  const userDataRedux = useSelector((state) => state.user.userData);

//   console.log(userDataRedux)
  const [contactInfo, setContactInfo] = useState({
    title: '',
    phone: '',
    email: '',
    location: '',
   
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactInfo(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${Base_Url}/contact`, { title: contactInfo.title,
        phone: contactInfo.phone,
        email: contactInfo.email,
        location: contactInfo.location,  created_by: userDataRedux.userid} );
      navigate('/contact');
    } catch (err) {
      setError('Failed to add contact information');
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Add Contact Information</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit} className="needs-validation" noValidate>
        <div className="form-group mb-3">
          <label htmlFor="title">Title:</label>
          <input
            type="text"
            className="form-control"
            id="title"
            name="title"
            value={contactInfo.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            className="form-control"
            id="phone"
            name="phone"
            value={contactInfo.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="title">Location:</label>
          <input
            type="text"
            className="form-control"
            id="location"
            name="location"
            value={contactInfo.location}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={contactInfo.email}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="btn btn-primary mb-5">Add Contact</button>
      </form>
    </div>
  );
};

export default AddContactInfo;
